<template>
   <div class="new-gift" v-if="isNewGiftShow">
      <!-- <div class="new-gift-cen">
        <img src="images/prize_new_1.png" class="new-gift-0" alt="" />
      </div> -->
			<p>恭喜您注册成功，188元新人专享优惠券已直达您的账户，前往App使用吧</p>
      <div class="new-gift-btn" @click="downLoadAppFn"></div>
    </div>
</template>
<script>
import { downLoadApp } from '../../common/utils/tool';
export default {
  props: {
    isNewGiftShow: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    downLoadAppFn(){
      downLoadApp();
    }
  },
};
</script>
<style scoped>
.new-gift{
	position: fixed;
  left: 50%;
  top: 109px;
  width: 292px;
  height: 368px;
  margin-left: -146px;
  background: url(images/pop-bg-03.png) no-repeat;
  background-size: auto 100%;
  z-index: 10;
}
/* .new-gift-cen{
  display: flex;
	align-items: center;
	justify-content: center;
  width: 180px;
  height: 130px;
  margin: 35px auto 15px;
}
.new-gift-cen img {
  display: block;
  transform: scale(.5);
} */
.new-gift p{
  padding: 180px 26px 0;
  font-size: 18px;
  color: #fff;
  line-height: 26px;
}
.new-gift-btn{
	position: absolute;
	width: 200px;
	height: 53px;
	bottom: 35px;
	left: 44px;
}
</style>
